import { render } from "./NewMembers.vue?vue&type=template&id=a6406210"
import script from "./NewMembers.vue?vue&type=script&lang=js"
export * from "./NewMembers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__